import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Typography} from 'views/components';
import {Translate} from 'views/module';

const CareViewResetQuestions = (props) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const resetQuestions = props.resetQuestions;
  const close = props.close;

  const submit = () => {
    setIsDeleting(true);
    resetQuestions();
  };

  return (
    <Dialog onClose={() => close()}>
      <DialogTitle onClose={() => close()}>
        <Translate expression='generic.ConfirmTheAction'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate
            expression='client.ClientDetail.CareviewSettings.ResetQuestions.AreYouSure'
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => close()}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={submit} loading={isDeleting}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CareViewResetQuestions.propTypes = {
  resetQuestions: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};
export default React.memo(CareViewResetQuestions);
